import React from "react";

import Tabs from "../../../../components/common/Tabs/Tabs";
import { ProductContent } from "../ProductContent/ProductContent";

import { HousingList } from "../../Constants/HousingTab.constants";
import { ResidentialList } from "../../Constants/ResidentialTab.constants";
import { BusinessList } from "../../Constants/BusinessTab.constants";
import { AutoList } from "../../Constants/AutoTab.constants";
import { HealthList } from "../../Constants/HealthTab.constants";

import * as S from "./ChooseProductSection.style";

const tabsList = [
  {
    id: 1,
    title: "Habitacional",
    anchorId: 1,
    content: (
      <>
        <ProductContent
          description={
            <>
              O nosso Seguro Habitacional cobre morte, invalidez permanente e
              danos ao lar causados por situações previstas no contrato, como
              alagamentos e explosões. Ele é{" "}
              <strong>
                obrigatório por lei para quem financiou uma moradia.
              </strong>{" "}
              Confira os nossos canais de atendimento de acordo com o que você
              precisa.
            </>
          }
          lists={HousingList}
        />
      </>
    ),
  },
  {
    id: 2,
    title: "Residencial",
    anchorId: 2,
    content: (
      <>
        <ProductContent
          description={
            <>
              Se você contratou o <strong>Seguro Residencial</strong>, vale
              lembrar que, diferente do Seguro Habitacional, ele{" "}
              <strong>não está vinculado ao financiamento do imóvel</strong>.
              Confira os nossos canais de atendimento de acordo com o que você
              precisa.
            </>
          }
          lists={ResidentialList}
        />
      </>
    ),
  },
  {
    id: 3,
    title: "Empresarial",
    anchorId: 3,
    content: (
      <>
        <ProductContent
          description={
            <>
              Voltado ao Microempreendedor Individual (MEI), pequenas, médias e
              grandes empresas. Também engloba loterias e Correspondentes Caixa
              Aqui (CCAs). Confira os nossos canais de atendimento de acordo com
              o que você precisa.
            </>
          }
          lists={BusinessList}
        />
      </>
    ),
  },
  {
    id: 4,
    title: "Auto",
    anchorId: 4,
    content: (
      <>
        <ProductContent
          hiddenBorder
          description={
            <>
              Confira os telefones para atendimento de acordo com o que você
              precisa.
            </>
          }
          lists={AutoList}
        />
      </>
    ),
  },
  {
    id: 5,
    title: "Saúde",
    anchorId: 5,
    content: (
      <>
        <ProductContent
          hiddenBorder
          description={<>Confira os telefones para atendimento.</>}
          lists={HealthList}
        />
      </>
    ),
  },
];

export const ChooseProductSection = () => {
  return (
    <S.ChooseProductContainer>
      <S.ChooseProductContent className="container">
        <S.ChooseProductTitle>
          Escolha o produto que você quer tratar!
        </S.ChooseProductTitle>

        <Tabs tabs={tabsList} />
      </S.ChooseProductContent>
    </S.ChooseProductContainer>
  );
};
